module.exports = __webpack_public_path__ + "img/logic_lo.cfa76aa3.jpg";